import { gql, useLazyQuery } from "@apollo/client";
import { ListBannerMainQuery, ListBannerMainQueryVariables } from "../generated/graphql";

const LIST_BANNER_MAIN_QUERY = gql`
  query listBannerMain($input: ListBannerMainInput!) {
    listBannerMain(input: $input) {
      ok
      err
      bannerMain {
        id
        index
        link
        mainType
        title
        name
        note
        alt
        isRes
        isEvent
        isFree
        isOnePlusOne
        upload {
          id
          uuid
          url
          filename
        }
        linkServices {
          id
          name
        }
      }
    }
  }
`;

export const useListBannerMain = (
  onCompleted?: (data: ListBannerMainQuery) => void
) => {
  return useLazyQuery<ListBannerMainQuery, ListBannerMainQueryVariables>(
    LIST_BANNER_MAIN_QUERY,
    { onCompleted, fetchPolicy: "network-only" }
  );
};
